import EA from 'helpers/init';

export default EA.Methods.imageLazyLoad = ($this) => {
    const imageEl = $this;
    let loaded = false;

    function createObserver() {
        let observer;

        let options = {
            root: null,
            rootMargin: '200px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(imageEl);
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !loaded) {
                imageEl.src = imageEl.dataset.src;
                loaded = true;
            }
        });
    }

    createObserver();
};
